<template>
  <div v-if="img" @click="methodHiddenPic">
    <div class="enlargeImg">
      <img :src="img" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    img: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  methods: {
    methodHiddenPic() {
      this.$emit('input', '')
    }
  }
}
</script>
<style lang="scss" scoped>
.enlargeImg {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.56);
  img {
    width: 300px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
